<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel">
        <span>Document Template</span>
    </h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>


<div class="card-header mt-3">

    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom card-header-tabs border-bottom-0 center justify-content-center" role="tablist">
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body " style="text-align: center" data-bs-toggle="tab" role="tab">
                <i class="fas fa-home"></i>
                <div i18n="@@ContactPopUp_tab_ContactDetails ">Details</div>
            </a>
            <ng-template ngbNavContent>
                <div class="gap-2 overflow-hidden">
                    <div class="col-lg-12 row col-auto justify-content-center"
                        style="display: flex; align-items: stretch; margin: auto;">
                        <div class="col-lg-6 d-grid ps-0">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">Details</h5>
                                </div>
                                <div class="card-body ">
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Template Name</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.name" placeholder="Enter name">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Description</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.description" placeholder="Enter Description">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">HTML Text</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.text" placeholder="Enter text">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Category</label>
                                        <div >
                                            <app-ng-select-layout [placeHolderText]="'Select Category'"
                                                [(model)]="model.categoryId" (change)="updateCategoryId();"
                                                [items]="categoryOptions"></app-ng-select-layout>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 d-grid " style="padding-left: 0px; ">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">Pricing</h5>
                                </div>
                                <div class="card-body ">

                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Price</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.price" placeholder="Enter text">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Processing Fee</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.processingFee" placeholder="Enter text">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Additional Fee</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.additionalFee" placeholder="Enter text">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 d-grid " style="padding-left: 0px; padding-right: 0px;">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">File Upload</h5>
                                </div>
                                <div class="card-body ">

                                    <div class="mb-3">
                                        <label class="" for="project-title-input">Document Template</label>


                                        <label class="form-label row col-auto "
                                            style=" cursor: pointer !important; padding-left: 0.8rem !important; padding-right: 0.6rem !important;"
                                            for="fileUpload">
                                            <div class=" form-control1 disabledBackgroundFormControl">
                                                Choose File
                                            </div>
                                            <div  class="form-control1 FormControlInputArea">
                                               {{model.document!.fileName! || defaultText}}
                                            </div>

                                        </label>
                                        <input accept=".doc, .docx" id="fileUpload" type="file" style="display:none;"
                                            (change)="uploadFile($event)">

                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Is Explicit Signature
                                            Required</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                [checked]="checkBoolValue(model.isExplicitIdentityRequired)"
                                                (change)="model.isExplicitIdentityRequired = !model.isExplicitIdentityRequired" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 d-grid" style="padding-right: 0px;">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">Thumbnail Image</h5>
                                </div>
                                <div class="card-body pt-0">
                                    <div class="mb-3">
                                        <div class="d-flex justify-content-center mb-1 mt-1">
                                            <div class="profile-user position-relative"
                                                style="height: 8.2rem; width: 8.2rem;">
                                                <div class="avatar-title bg-light rounded-corner">
                                                    <img [src]="coverImageURL" class=" rounded-corner object-cover"
                                                        style="height: 7rem; width: 7rem;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-0 rounded-circle profile-photo-edit">
                                            <input accept="image/png, image/jpeg" class="form-control" style="line-height: 1.7;" type="file"
                                                (change)="uploadPhotoDirectly(model, $event, enumEntityFileType.CoverPhoto)"
                                                #fileUpload>
                                        </div>

                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Is Icon</label>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                [checked]="checkBoolValue(model.isIcon)"
                                                (change)="model.isIcon = !model.isIcon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card mb-2">
                            <div class="card-body pt-0">
                                <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
                                    [serviceData]="serviceData" (buttonActionSelected)="buttonActionSelected($event)"
                                    (updateCheckedValues)="checkedValGet =  $event"
                                    (rowActionSelected)="rowActionSelected($event)"
                                    (filterSelected)="filterSelected($event)"></app-list-layout>
                            </div>
                        </div>

                    </div>

                </div>
            </ng-template>

        </li>

        <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Attachments</span>
            </a>

            <ng-template ngbNavContent>
                <span *ngIf="newModel == false">
                    <app-file-management [entityId]="model.id" [entityTypeId]="entityTypeId"
                        [entityName]="model.name"></app-file-management>
                </span>
                <span *ngIf="newModel == true">
                    <app-file-management [filesIdsToAdd]="model.fileUpload.fileIdsToAdd"
                        (filesIdsToAddChanged)="onNewModalEntityFileIdsAdded(model,$event)" [entityName]="model.name"
                        [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
                </span>
            </ng-template>

        </li>


    </ul>

    <div class="card-body p-4  ">

        <div [ngbNavOutlet]="customNav" class="mb-3"></div>

        <div class="hstack justify-content-end gap-2" style="margin-top: 0.5rem;">
            <button *ngIf="newModel === false" [disabled]="disableEditing" type="button" class="btn btn-danger"
                id="add-btn" (click)="onDelete()" i18n="">Delete</button>


            <button *ngIf="newModel" [disabled]="disableEditing" type="button" class="btn btn-success" id="add-btn"
                (click)="onCreate()" i18n="">Create</button>
            <button *ngIf="newModel === false" [disabled]="disableEditing" type="button" class="btn btn-success"
                id="add-btn" (click)="onUpdate()" i18n="">Update</button>
        </div>

    </div>
</div>